import classnames from 'classnames';
import { useLocale } from 'next-intl';
import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';

import { responsive } from '../../helpers/carousel-helper';

import {
    ImageKinofestBanner_1,
    ImageKinofestBannerTrailing_1_DE,
    ImageKinofestBannerTrailing_1_EN,
    isBeforeKinofest,
    kinofestCinemas
} from './kinofest-constants';
import KinofestBannerItem, { KinofestBannerItemSize } from './KinofestBannerItem';

export default function KinofestBanner({
    cinemaId,
    itemSize
}: {
    cinemaId?: CinemaDto['id'];
    itemSize?: KinofestBannerItemSize;
}) {
    const locale = useLocale();
    const isKinofestCinema = kinofestCinemas.includes(cinemaId);

    if (isBeforeKinofest && isKinofestCinema) {
        const slides = [
            {
                backgroundImage: ImageKinofestBanner_1,
                backgroundColor: 'bg-[#1C2661]',
                trailingImage: locale === 'de' ? ImageKinofestBannerTrailing_1_DE : ImageKinofestBannerTrailing_1_EN,
                classNameLeadingImage: 'object-[0px_10%]'
            }
        ];
        return (
            <Carousel
                className={classnames('h-auto w-full')}
                responsive={responsive}
                arrows={false}
                autoPlay={slides.length > 1}
                autoPlaySpeed={8000}
                infinite={slides.length > 1}
                shouldResetAutoplay
                draggable={slides.length > 1}
                swipeable={slides.length > 1}>
                {slides.map((slide, index) => (
                    <KinofestBannerItem
                        key={`KinofestBannerItem#${index}`}
                        backgroundImage={slide.backgroundImage}
                        classNameBackground={slide.backgroundColor}
                        classNameLeadingImage={slide.classNameLeadingImage}
                        trailingImage={slide.trailingImage}
                        size={itemSize}
                    />
                ))}
            </Carousel>
        );
    }

    return null;
}
